var exports = {
  "Nr": "SubscriptionCard.module__card___YUJQYT",
  "Vg": "SubscriptionCard.module__grid___YUJQYT",
  "Qs": "SubscriptionCard.module__content___YUJQYT",
  "wx": "SubscriptionCard.module__header___YUJQYT",
  "DD": "SubscriptionCard.module__title___YUJQYT",
  "h_": "SubscriptionCard.module__description___YUJQYT",
  "h9": "SubscriptionCard.module__renewalInfo___YUJQYT",
  "w$": "SubscriptionCard.module__pendingChangeInfo___YUJQYT",
  "o1": "SubscriptionCard.module__actions___YUJQYT",
  "hP": "SubscriptionCard.module__actionButton___YUJQYT",
  "H2": "SubscriptionCard.module__legacyRateBadge___YUJQYT",
};

module.exports = exports;
